<template>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
            <table class="table text-align-left mb-0">
                <thead>
                    <tr>
                        <th>Date </th>
                        <th> Dealer</th>
                        <th>Retailer </th>
                        <th>SubRetailer </th>
                        <th> Amount</th>
                        <!--<th class="
                          text-center text-uppercase text-secondary text-xxs
                          font-weight-bolder
                          opacity-7
                        ">
                            Reference Number
                        </th>-->
                        <th> Particulars </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="filter-background">
                        <td>
                            <Datepicker class="form-control p-0 m-0 border" :enable-time-picker="false" v-model="filters.dateRange" multi-calendars
                                range />
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input type="text" class="form-control" placeholder="Filter Dealer"
                                    v-model="filters.dealer" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input type="text" class="form-control" placeholder="Filter Retailer"
                                    v-model="filters.retailer" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input type="text" class="form-control" placeholder="Filter Sub Retailer"
                                    v-model="filters.subRetailer" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input type="number" class="form-control" placeholder="Filter Amount"
                                    v-model="filters.amount" />
                            </div>
                        </td>
                        <!--<td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input type="text" class="form-control" placeholder="Filter Reference No."
                             />
                            </div>
                        </td>-->
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input type="text" class="form-control" placeholder="Filter Particulars"
                                    v-model="filters.particulars" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="loading">
                        <td colspan="7">
                            <div class="text-center">
                                <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!loading && pageItems.length == 0">
                        <td colspan="7">
                            <div class="text-center">
                                <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
                                <p class="text-xs font-weight-bold">No Data Found</p>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(transaction, index) in pageItems" :key="index">
                        <td>
                            {{ $format.FormatFullDateTime(transaction.timestamp) }}
                        </td>
                        <td>
                            {{ transaction.retailerName }}
                            <!--<div class="d-flex px-2 py-1">
                            <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ transaction.retailer.name }}</h6>
                            <p class="text-xs text-secondary mb-0">
                                {{ transaction.retailer.corporateID }}
                            </p>
                            </div>
                        </div>-->
                        </td>
                        <td>
                            {{ transaction.subRetailerName || "-" }}
                        </td>
                        <td>
                            {{ transaction.subRetailerUserName || "-"}}
                        </td>
                        <td>
                            <span class="badge badge-sm bg-gradient-info">
                                Php {{ (transaction.credit - transaction.debit).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                            </span>
                        </td>
                        <td>
                            {{ transaction.particulars }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="paginate-div d-flex align-items-end mt-3 me-3 custom-pagination">
            <vue-awesome-paginate class="ms-auto" :max-pages-shown="5" :total-items="transactions.length"
                :items-per-page="itemPerPage" :on-click="onPageChanged" v-model="currentPage" />
        </div>
    </div>
</template>

<style>
    .custom-pagination .paginate-buttons {
        min-width: 35px;
        width: auto !important; /*override the default width to better show pagination at 3 digits*/
    }
</style>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../assets/no-data.json";
import searchingJSON from "./../../../assets/searching.json";

export default {
    data() {
        return {
            noDataJSON,
            searchingJSON,
            itemPerPage: 20,
            pageItems: [],
            filters: {
                dealer: '',
                retailer: '',
                subRetailer: '',
                particulars: '',
                amount: '',
                dateRange: [],
            },
        };
    },
    computed: {
        ...mapState({
            currentPage: (state) => state.retailerController.transactionsCurrentPage,
            loading: (state) => state.retailerController.topUpsLoading,
            transactions: (state) => state.retailerController.topUps,
        }),
        filteredTransactions() {
            return this.transactions.filter(tx => {
                const {
                    dealer,
                    retailer,
                    subRetailer,
                    particulars,
                    amount,
                    dateRange,
                } = this.filters;

                const inRange =
                    Array.isArray(dateRange) &&
                        dateRange.length === 2 &&
                        dateRange[0] &&
                        dateRange[1]
                        ? (() => {
                            const start = new Date(dateRange[0]);
                            start.setHours(0, 0, 0, 0); // Set to 00:00

                            const end = new Date(dateRange[1]);
                            end.setDate(end.getDate() + 1); // Include full day by adding 1
                            end.setHours(0, 0, 0, 0); // Set to 00:00 of the next day

                            return new Date(tx.timestamp) >= start && new Date(tx.timestamp) < end;
                        })()
                        : true;

                return (
                    (!dealer || tx.retailerName?.toLowerCase().includes(dealer.toLowerCase())) &&
                    (!retailer || tx.subRetailerName?.toLowerCase().includes(retailer.toLowerCase())) &&
                    (!subRetailer || tx.subRetailerUserName?.toLowerCase().includes(subRetailer.toLowerCase())) &&
                    (!particulars || tx.particulars?.toLowerCase().includes(particulars.toLowerCase())) &&
                    (!amount || (tx.credit - tx.debit)?.toString().includes(amount)) &&
                    inRange
                );
            });
        },
    },
    watch: {
        transactions: {
            handler(newValue, oldValue) {
                this.onPageChanged(1);
            },
            deep: true,
        },
        filters: {
            handler() {
                this.onPageChanged(1);
            },
            deep: true,
        },
        'filters.dateRange'(newRange) {
            if (Array.isArray(newRange) && newRange.length === 2 && newRange[0] && newRange[1]) {
                const start = new Date(newRange[0]);
                const end = new Date(newRange[1]);

                const needsFix =
                    start.getHours() !== 0 ||
                    start.getMinutes() !== 0 ||
                    start.getSeconds() !== 0 ||
                    start.getMilliseconds() !== 0 ||
                    end.getHours() !== 23 ||
                    end.getMinutes() !== 59;

                if (needsFix) {
                    start.setHours(0, 0, 0, 0);
                    end.setHours(23, 59, 59, 999);

                    this.filters.dateRange = [start, end];
                    return; // Skip rest to avoid double API call
                }

                const dateFrom = start.toISOString();
                const dateTo = end.toISOString();

                this.$store.commit("retailerController/SET_TopUpsFilter", {
                    ...this.$store.state.retailerController.topUpsFilter,
                    dateRange: [start, end],
                });

                this.getTopUpHistory({ dateFrom, dateTo });
            }
        }

    },
    methods: {
        ...mapActions({
            getTopUpHistory: "retailerController/GetTopUpHistory",
        }),
        ...mapMutations({
            setCurrentPage: "retailerController/SET_TransactionsCurrentPage",
        }),
        onPageChanged(page) {
            this.setCurrentPage(page);
            this.pageItems = this.filteredTransactions.slice(
                (this.currentPage - 1) * this.itemPerPage,
                this.currentPage * this.itemPerPage
            );
        },
    },
    async mounted() {
        const today = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(today.getDate() - 7);

        this.filters.dateRange = [oneWeekAgo, today];

        const dateFrom = oneWeekAgo.toISOString().split("T")[0];
        const dateTo = today.toISOString().split("T")[0];

        await this.getTopUpHistory({ dateFrom, dateTo });
    },
};
</script>